<template>
  <div id="app" v-loading="$store.state.loading" style="min-height: 100vh">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="less">
@import "./assets/less/main.less";
@import "./assets/glide.core.css";
.wrapper {
  min-height: 100vh;
}
</style>
<style>
.slider-box:before {
  content: " ";
  width: 100%;
  height: 50%;
  position: absolute;
  background: rgb(0, 0, 0);
  background: linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);
  background: -webkit-gradient(
    linear,
    left bottom,
    left top,
    from(#000000),
    to(rgba(0, 0, 0, 0))
  );
  bottom: 0;
  display: block !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue